<template>
  <div class="baseForm">
    <el-form
      :model="baseData"
      :rules="rules"
      ref="baseForm"
      :disabled="
        returnStatus == 'ZT02' ||
        returnStatus == 'ZT03' ||
        returnStatus == 'ZT07' ||
        returnStatus == 'ZT08'
      "
      label-width="120px"
    >
      <el-row>
        <!-- 销售退换货单号 -->
        <el-col :span="6">
          <el-form-item
            :label="
              type == '1'
                ? this.$t('returnDetail.baseForm.returnNo')
                : this.$t('returnDetail.baseForm.changeNo')
            "
            prop="returnNo"
          >
            <el-input
              disabled
              :placeholder="
                type == '1'
                  ? this.$t('returnDetail.baseForm.returnNoPlaceholder')
                  : this.$t('returnDetail.baseForm.changeNoPlaceholder')
              "
              v-model="baseData.returnNo"
            ></el-input>
          </el-form-item>
        </el-col>
        <!-- 公司 -->
        <el-col :span="6">
          <el-form-item
            :label="this.$t('returnDetail.baseForm.returnCompanyCode')"
            prop="returnCompanyCode"
          >
            <el-select
              clearable
              @change="changeCompany"
              @focus="focusChange"
              @blur="changeBlur"
              class="widthStyle"
              v-model="baseData.returnCompanyCode"
              filterable
              :placeholder="this.$t('returnDetail.baseForm.returnCompanyCodePlaceholder')"
            >
              <el-option
                v-for="item in companyOptions"
                :key="item.personCompanyCode"
                :label="item.personCompanyName"
                :value="item.personCompanyCode"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <!-- 业务部门 -->
        <el-col :span="6">
          <el-form-item
            :label="this.$t('returnDetail.baseForm.returnDepartmentCode')"
            prop="returnDepartmentCode"
          >
            <el-select
              clearable
              class="widthStyle"
              @change="changeDepartment"
              v-model="baseData.returnDepartmentCode"
              filterable
              :placeholder="this.$t('returnDetail.baseForm.returnDepartmentCodePlaceholder')"
            >
              <el-option
                v-for="item in departmentOptions"
                :key="item.personDepartmentCode"
                :label="item.personDepartmentName"
                :value="item.personDepartmentCode"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <!-- 操作人 -->
        <el-col :span="6">
          <el-form-item
            :label="this.$t('returnDetail.baseForm.returnOperatorCode')"
            prop="returnOperatorCode"
          >
            <search-table
              ref="SearchTable"
              v-model="baseData.returnOperatorName"
              searchType="personnel"
              propCode="id"
              :disabled="true"
              :isMultiple="true"
              :isNeedMultipleValue="true"
              :currentValue="baseData.returnOperatorName || null"
              :checkRowKeys="[baseData.returnOperatorNo]"
              @input="setReturnOperatorCode"
            ></search-table>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <!-- 业务员 -->
        <el-col :span="6">
          <el-form-item
            :label="this.$t('returnDetail.baseForm.returnSalesmanCode')"
            prop="returnSalesmanCode"
          >
            <search-table
              v-model="baseData.returnSalesmanName"
              searchType="personnel"
              :disabled="returnStatus == 'ZT02' || returnStatus == 'ZT03' || returnStatus == 'ZT07'"
              :isMultiple="true"
              :isNeedMultipleValue="true"
              :currentValue="baseData.returnSalesmanName || null"
              :checkRowKeys="[baseData.returnSalesmanNo]"
              @input="setReturnSalesmanCode"
            ></search-table>
          </el-form-item>
        </el-col>
        <!-- 客户 -->
        <el-col :span="6">
          <el-form-item
            :label="this.$t('returnDetail.baseForm.purchaseUnitNo')"
            prop="purchaseUnitNo"
          >
            <search-table
              v-model="baseData.purchaseUnitName"
              searchType="customer"
              :disabled="returnStatus == 'ZT02' || returnStatus == 'ZT03' || returnStatus == 'ZT07'"
              :isMultiple="true"
              :isNeedMultipleValue="true"
              :currentValue="baseData.purchaseUnitName || null"
              :checkRowKeys="[baseData.purchaseUnitNo]"
              @input="setPurchaseUnitNo"
              :extraData="baseData.extraDatapCustomer || {}"
            ></search-table>
          </el-form-item>
        </el-col>
        <!-- 合同号 -->
        <el-col :span="6">
          <el-form-item :label="this.$t('returnDetail.baseForm.contractNo')" prop="contractNo">
            <SearchModal
              ref="searchModal"
              propName="contractNo"
              propCode="contractNo"
              className="customer-search"
              model="contractNo"
              :placeholder="$t('returnDetail.baseForm.contractNoPlaceholder')"
              :API="saleContract.API"
              :query="saleContract.query"
              :page="true"
              :disabled="returnStatus == 'ZT02' || returnStatus == 'ZT03' || returnStatus == 'ZT07'"
              :searchColumns="saleContract.searchColumns"
              :columnList="saleContract.columnList"
              :extraData="saleContract.extraData"
              :isMultiple="true"
              :currentValue="baseData.contractNo"
              @setSearchModal="setSearchModal"
            ></SearchModal>
          </el-form-item>
        </el-col>
        <!-- 实物退换 -->
        <!--        <el-col :span="6">
          <el-form-item
            :label="this.$t('returnDetail.baseForm.returnRealObject')"
            prop="returnRealObject"
          >
            <el-radio-group v-model="baseData.returnRealObject" @change="changereturnRealObject(baseData.returnRealObject)">
              <el-radio label="0">{{this.$t('salePurchase.message.yes')}}</el-radio>
              <el-radio label="1">{{this.$t('salePurchase.message.no')}}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>-->
        <!-- 退货方式 -->
        <el-col :span="6">
          <el-form-item :label="this.$t('returnDetail.baseForm.returnMethod')" prop="returnMethod">
            <el-select
              clearable
              class="widthStyle"
              v-model="baseData.returnMethod"
              filterable
              :placeholder="this.$t('returnDetail.baseForm.returnMethodPlaceholder')"
              @change="changeReturnMethod"
            >
              <el-option
                v-for="item in returnList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <!-- 是否退款 -->
        <el-col :span="6">
          <el-form-item :label="this.$t('returnDetail.baseForm.returnMoney')" prop="returnMoney">
            <el-select
              clearable
              class="widthStyle"
              v-model="baseData.returnMoney"
              filterable
              @change="changeReturnMoney"
              :placeholder="this.$t('returnDetail.baseForm.returnMoneyPlaceholder')"
            >
              <el-option
                v-for="item in returnMoneyList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <!-- 退款方式 -->
        <el-col :span="6">
          <el-form-item
            :label="this.$t('returnDetail.baseForm.returnMoneyMethod')"
            prop="returnMoneyMethod"
            :rules="baseData.returnMoney == '0' ? baseDataRules.returnMoneyMethod : []"
          >
            <el-select
              clearable
              class="widthStyle"
              v-model="baseData.returnMoneyMethod"
              filterable
              :disabled="baseData.returnMoney == '0' ? false : true"
              :placeholder="this.$t('returnDetail.baseForm.returnMoneyMethodPlaceholder')"
            >
              <el-option
                v-for="item in returnMoneyMethodList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <!-- 总金额 -->
        <el-col :span="6">
          <el-form-item
            :label="this.$t('returnDetail.baseForm.returnMoneyAmount')"
            prop="returnMoneyAmount"
          >
            <el-input
              disabled
              :placeholder="this.$t('returnDetail.baseForm.returnMoneyAmountPlaceholder')"
              v-model="baseData.returnMoneyAmount"
              :precision="this.$globalVar.aPoint"
            ></el-input>
          </el-form-item>
        </el-col>
        <!-- 运输方式 -->
        <el-col :span="6">
          <el-form-item
            :label="this.$t('returnDetail.baseForm.deliveryMethod')"
            prop="deliveryMethod"
          >
            <el-select
              clearable
              class="widthStyle"
              v-model="baseData.deliveryMethod"
              filterable
              :placeholder="this.$t('returnDetail.baseForm.deliveryMethodPlaceholder')"
            >
              <el-option
                v-for="item in deliveryMethodList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="type == '0'">
        <!-- 换货方式 -->
        <el-col :span="6">
          <el-form-item :label="this.$t('returnDetail.baseForm.changeMethod')" prop="changeMethod">
            <el-select
              clearable
              class="widthStyle"
              v-model="baseData.changeMethod"
              filterable
              :placeholder="this.$t('returnDetail.baseForm.changeMethodPlaceholder')"
            >
              <el-option
                v-for="item in changeList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <!-- 换货地点 -->
        <el-col :span="6">
          <el-form-item
            :label="this.$t('returnDetail.baseForm.exchangeAddress')"
            prop="exchangeAddress"
          >
            <el-input
              :placeholder="this.$t('returnDetail.baseForm.exchangeAddressPlaceholder')"
              v-model="baseData.exchangeAddress"
              clearable
              :maxlength="32"
            ></el-input>
          </el-form-item>
        </el-col>
        <!-- 出库仓库 -->
        <el-col :span="6">
          <el-form-item
            :label="this.$t('returnDetail.baseForm.outboundStorageNo')"
            prop="outboundStorageNo"
          >
            <search-table
              v-model="baseData.outboundStorageName"
              searchType="warehouse"
              :disabled="returnStatus == 'ZT02' || returnStatus == 'ZT03' || returnStatus == 'ZT07'"
              :isMultiple="true"
              :isNeedMultipleValue="true"
              :currentValue="baseData.outboundStorageName || null"
              :checkRowKeys="[baseData.outboundStorageNo]"
              @input="setOutboundStorageNo"
            ></search-table>
          </el-form-item>
        </el-col>
        <!-- 出库费承担 -->
        <el-col :span="6">
          <el-form-item
            :label="this.$t('returnDetail.baseForm.outboundExpenseTaker')"
            prop="outboundExpenseTaker"
          >
            <el-select
              clearable
              class="widthStyle"
              v-model="baseData.outboundExpenseTaker"
              filterable
              :placeholder="this.$t('returnDetail.baseForm.outboundExpenseTakerPlaceholder')"
            >
              <el-option
                v-for="item in deliveryExpenseTakerList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <!-- 客户交货地点 -->
        <el-col :span="6">
          <el-form-item
            :label="this.$t('returnDetail.baseForm.deliveryAddress')"
            prop="deliveryAddress"
          >
            <el-input
              :placeholder="this.$t('returnDetail.baseForm.deliveryAddressPlaceholder')"
              v-model="baseData.deliveryAddress"
              clearable
              :maxlength="32"
            ></el-input>
          </el-form-item>
        </el-col>
        <!-- 预计退货日期 -->
        <el-col :span="6">
          <el-form-item
            :label="
              type == '1'
                ? this.$t('returnDetail.baseForm.predictReturnAddress')
                : this.$t('returnDetail.baseForm.predictExchangeAddress')
            "
            prop="predictExchangeAddress"
          >
            <el-date-picker
              class="widthStyle"
              clearable
              v-model="baseData.predictExchangeAddress"
              type="date"
              value-format="yyyy-MM-dd"
              format="yyyy-MM-dd"
              :placeholder="
                type == '1'
                  ? this.$t('returnDetail.baseForm.predictReturnAddressPlaceholder')
                  : this.$t('returnDetail.baseForm.predictExchangeAddressPlaceholder')
              "
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <!-- 入库仓库 -->
        <el-col :span="6">
          <el-form-item
            :label="this.$t('returnDetail.baseForm.inboundStorageNo')"
            prop="inboundStorageNo"
          >
            <search-table
              v-model="baseData.inboundStorageName"
              searchType="warehouse"
              :disabled="returnStatus == 'ZT02' || returnStatus == 'ZT03' || returnStatus == 'ZT07'"
              :isMultiple="true"
              :isNeedMultipleValue="true"
              :currentValue="baseData.inboundStorageName || null"
              :checkRowKeys="[baseData.inboundStorageNo]"
              @input="setInboundStorageNo"
            ></search-table>
          </el-form-item>
        </el-col>
        <!-- 销售出库仓库 -->
        <el-col :span="6">
          <el-form-item
            :label="this.$t('returnDetail.baseForm.outboundStorageNo')"
            prop="outboundStorageNo"
          >
            <search-table
              v-model="baseData.outboundStorageName"
              searchType="warehouse"
              :disabled="returnStatus == 'ZT02' || returnStatus == 'ZT03' || returnStatus == 'ZT07'"
              :isMultiple="true"
              :isNeedMultipleValue="true"
              :currentValue="baseData.outboundStorageName || null"
              :checkRowKeys="[baseData.outboundStorageNo]"
              @input="setOutboundStorageNo"
            ></search-table>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <!-- 运费承担 -->
        <el-col :span="6">
          <el-form-item
            :label="this.$t('returnDetail.baseForm.deliveryExpenseTaker')"
            prop="deliveryExpenseTaker"
          >
            <el-select
              clearable
              class="widthStyle"
              v-model="baseData.deliveryExpenseTaker"
              filterable
              :placeholder="this.$t('returnDetail.baseForm.deliveryExpenseTakerPlaceholder')"
            >
              <el-option
                v-for="item in deliveryExpenseTakerList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <!-- 运费金额 -->
        <el-col :span="6">
          <el-form-item
            :label="this.$t('returnDetail.baseForm.deliveryExpenseAmount')"
            prop="deliveryExpenseAmount"
          >
            <input-number
              disabled
              v-model="baseData.deliveryExpenseAmount"
              :max="'99999999999999.99'"
              :placeholder="this.$t('returnDetail.baseForm.deliveryExpenseAmountPlaceholder')"
            ></input-number>
          </el-form-item>
        </el-col>
        <!-- 入库费承担 -->
        <el-col :span="6">
          <el-form-item
            :label="this.$t('returnDetail.baseForm.inboundExpenseTaker')"
            prop="inboundExpenseTaker"
          >
            <el-select
              clearable
              class="widthStyle"
              v-model="baseData.inboundExpenseTaker"
              filterable
              :placeholder="this.$t('returnDetail.baseForm.inboundExpenseTakerPlaceholder')"
            >
              <el-option
                v-for="item in deliveryExpenseTakerList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <!-- 入库费金额 -->
        <el-col :span="6">
          <el-form-item
            :label="this.$t('returnDetail.baseForm.inboundExpenseAmount')"
            prop="inboundExpenseAmount"
          >
            <input-number
              v-model="baseData.inboundExpenseAmount"
              :max="'99999999999999.99'"
              :clearable="true"
              :placeholder="this.$t('returnDetail.baseForm.inboundExpenseAmountPlaceholder')"
            ></input-number>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <!-- 制单日期 -->
        <el-col :span="6">
          <el-form-item :label="this.$t('returnDetail.baseForm.gmtCreate')" prop="gmtCreate">
            <el-date-picker
              disabled
              class="widthStyle"
              v-model="baseData.gmtCreate"
              type="date"
              value-format="yyyy-MM-dd"
              format="yyyy-MM-dd"
              :placeholder="this.$t('returnDetail.baseForm.gmtCreatePlaceholder')"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <!-- 出库费金额 -->
        <el-col :span="6" v-if="type == '0'">
          <el-form-item
            :label="this.$t('returnDetail.baseForm.outboundExpenseAmount')"
            prop="outboundExpenseAmount"
          >
            <el-input
              :placeholder="this.$t('returnDetail.baseForm.outboundExpenseAmountPlaceholder')"
              v-model="baseData.outboundExpenseAmount"
              :maxlength="32"
              clearable
            ></el-input>
          </el-form-item>
        </el-col>
        <!-- 货币 -->
        <el-col :span="6">
          <el-form-item label="币种" prop="currencyName">
            <ajax-select
              disabled
              v-model="baseData.currencyCode"
              :apiUrl="currencyApi"
              :apiData="currencyData"
              valueKey="currencyCode"
              moreShowKey="currencyCode"
              labelKey="currencyName"
              method="get"
            ></ajax-select>
          </el-form-item>
        </el-col>
        <!-- 总退换货数量 -->
        <el-col :span="6">
          <el-form-item
            :label="
              type == '1'
                ? this.$t('returnDetail.baseForm.totalReturnQuantity')
                : this.$t('returnDetail.baseForm.totalExchangeQuantity')
            "
            prop="totalExchangeQuantity"
          >
            <el-input
              disabled
              :placeholder="
                type == '1'
                  ? this.$t('returnDetail.baseForm.totalReturnQuantityPlaceholder')
                  : this.$t('returnDetail.baseForm.totalExchangeQuantityPlaceholder')
              "
              v-model="baseData.totalExchangeQuantity"
            ></el-input>
          </el-form-item>
        </el-col>
        <!-- 未开票总数 -->
        <el-col :span="6">
          <el-form-item
            :label="this.$t('returnDetail.baseForm.nonInvoiceQuantity')"
            prop="nonInvoiceQuantity"
          >
            <el-input
              disabled
              :placeholder="this.$t('returnDetail.baseForm.nonInvoiceQuantityPlaceholder')"
              v-model="baseData.nonInvoiceQuantity"
            ></el-input>
          </el-form-item>
        </el-col>
        <!-- 贸易类型 -->
        <el-col :span="6">
          <el-form-item :label="this.$t('returnDetail.baseForm.tradeType')" prop="tradeType">
            <el-select
              clearable
              class="widthStyle"
              v-model="baseData.tradeType"
              filterable
              disabled
              :placeholder="this.$t('returnDetail.baseForm.tradeTypePlaceholder')"
            >
              <el-option
                v-for="item in tradeTypeList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <!-- 已开票金额 -->
        <el-col :span="6">
          <el-form-item
            :label="this.$t('returnDetail.baseForm.invoiceAmount')"
            prop="invoiceAmount"
          >
            <el-input
              disabled
              :placeholder="this.$t('returnDetail.baseForm.invoiceAmountPlaceholder')"
              v-model="baseData.invoiceAmount"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="this.$t('returnDetail.baseForm.isDirectDeliver')"
            prop="isDirectDeliver"
          >
            <el-select
              class="inputWidth"
              :placeholder="this.$t('returnDetail.baseForm.isDirectDeliverPlaceholder')"
              v-model="baseData.isDirectDeliver"
            >
              <el-option :label="$t('addSupplierDelivery.option.direct')" value="1"></el-option>
              <el-option :label="$t('addSupplierDelivery.option.notDirect')" value="0"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <!-- 备注 -->
        <el-col :span="24">
          <el-form-item :label="this.$t('returnDetail.baseForm.mark')" prop="mark">
            <el-input
              v-model="baseData.mark"
              :placeholder="this.$t('returnDetail.baseForm.markPlaceholder')"
              type="textarea"
              :rows="3"
              :maxlength="256"
              clearable
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  import { dateFormatter } from '@/common/js/util';
  import SearchTable from '@/components/form-item/search-table';
  import InputNumber from '@/components/form-item/input-number';
  import DataBaseAPI from '@/api/dataBase';
  import SearchModal from '@/components/SearchModal';
  import API from '@/api/purchaseSalesCenter/salesReturnsAndExchange';
  import ajaxSelect from '@/components/form-item/ajax-select';

  export default {
    name: 'returnAdd',
    components: {
      SearchTable,
      SearchModal,
      InputNumber,
      ajaxSelect,
    },
    props: ['type'],
    data() {
      return {
        rules: {},
        returnStatus: '',
        baseData: {
          id: null,
          returnNo: null,
          returnCompanyCode: null,
          returnCompanyName: null,
          returnDepartmentCode: null,
          returnDepartmentName: null,
          returnOperatorCode: null,
          returnOperatorName: null,
          returnSalesmanCode: null,
          returnSalesmanName: null,
          purchaseUnitNo: null,
          purchaseUnitName: null,
          returnRealObject: '0',
          returnMethod: null,
          changeMethod: null,
          returnMoney: null,
          isDirectDeliver: null,
          returnMoneyMethod: null,
          returnMoneyAmount: null,
          deliveryAddress: null,
          exchangeAddress: null,
          predictExchangeAddress: null,
          inboundStorageNo: null,
          inboundStorageName: null,
          outboundExpenseTaker: null,
          outboundStorageName: null,
          outboundStorageNo: null,
          deliveryMethod: null,
          deliveryExpenseTaker: null,
          deliveryExpenseAmount: null,
          inboundExpenseTaker: null,
          outboundExpenseAmount: null,
          inboundExpenseAmount: null,
          currencyCode: '',
          currencyName: this.$t('salePurchase.RMB'),
          totalExchangeQuantity: null,
          mark: null,
          gmtCreate: dateFormatter(new Date()),
          nonInvoiceQuantity: 0,
          tradeType: null,
          invoiceAmount: null,
          contractNo: null,
          currencyExchangeRate: 1,
        },
        deliveryAddress: '',
        departmentOptions: [],
        companyOptions: [],
        returnMoneyList: [
          { value: '1', label: this.$t('salePurchase.message.no') },
          { value: '0', label: this.$t('salePurchase.message.yes') },
        ],
        currencyApi: '',
        currencyData: {}, //货币种类
      };
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
        // 退货方式
        returnList(state) {
          if (state.dict.dictList.length > 10) {
            return state.dict.dictList.find((it) => it.dictType == 'sales_return_method').dictList;
          }
        },
        // 换货方式
        changeList(state) {
          if (state.dict.dictList.length > 10) {
            return state.dict.dictList.find((it) => it.dictType == 'change_method').dictList;
          }
        },
        // 运费承担
        deliveryExpenseTakerList(state) {
          if (state.dict.dictList.length > 10) {
            return state.dict.dictList.find((it) => it.dictType == 'sales_freight_taker').dictList;
          }
        },
        // 运输方式
        deliveryMethodList(state) {
          if (state.dict.dictList.length > 10) {
            return state.dict.dictList.find((it) => it.dictType == 'delivery_method').dictList;
          }
        },
        // 退款方式
        returnMoneyMethodList(state) {
          if (state.dict.dictList.length > 10) {
            return state.dict.dictList.find((it) => it.dictType == 'return_money_method').dictList;
          }
        },
        // 贸易类型
        tradeTypeList(state) {
          if (state.dict.dictList.length > 10) {
            return state.dict.dictList.find((it) => it.dictType == 'sale-trade-type').dictList;
          }
        },
      }),
      baseDataRules() {
        return {
          returnDepartmentCode: [
            {
              required: true,
              message: this.$t('returnDetail.baseForm.returnDepartmentCodePlaceholder'),
            },
          ],
          returnSalesmanCode: [
            {
              required: true,
              message: this.$t('returnDetail.baseForm.returnSalesmanCodePlaceholder'),
            },
          ],
          returnCompanyCode: [
            {
              required: true,
              message: this.$t('returnDetail.baseForm.returnCompanyCodePlaceholder'),
            },
          ],
          purchaseUnitNo: [
            {
              required: true,
              message: this.$t('returnDetail.baseForm.purchaseUnitNoPlaceholder'),
            },
          ],
          returnRealObject: [
            {
              required: true,
              message: this.$t('returnDetail.baseForm.returnRealObjectPlaceholder'),
            },
          ],
          returnMethod: [
            {
              required: true,
              message: this.$t('returnDetail.baseForm.returnMethodPlaceholder'),
            },
          ],
          returnMoney: [
            {
              required: true,
              message: this.$t('returnDetail.baseForm.returnMoneyPlaceholder'),
            },
          ],
          returnMoneyMethod: [
            {
              required: true,
              message: this.$t('returnDetail.baseForm.returnMoneyMethodPlaceholder'),
            },
          ],
          isDirectDeliver: [
            {
              required: true,
              message: this.$t('returnDetail.baseForm.isDirectDeliverPlaceholder'),
            },
          ],
          deliveryAddress: [
            {
              required: true,
              message: this.$t('returnDetail.baseForm.deliveryAddressPlaceholder'),
            },
          ],
          predictExchangeAddress: [
            {
              required: true,
              message: this.$t('returnDetail.baseForm.predictExchangeAddressPlaceholder'),
            },
          ],
          changeMethod: [
            {
              required: true,
              message: this.$t('returnDetail.baseForm.changeMethodPlaceholder'),
            },
          ],
          outboundStorageNo: [
            {
              required: true,
              message: this.$t('returnDetail.baseForm.outboundStorageNoPlaceholder'),
            },
          ],
          outboundExpenseTaker: [
            {
              required: true,
              message: this.$t('returnDetail.baseForm.outboundExpenseTakerPlaceholder'),
            },
          ],
          exchangeAddress: [
            {
              required: true,
              message: this.$t('returnDetail.baseForm.exchangeAddressPlaceholder'),
            },
          ],
          deliveryMethod: [
            {
              required: true,
              message: this.$t('returnDetail.baseForm.deliveryMethodPlaceholder'),
            },
          ],
          inboundStorageNo: [
            {
              required: true,
              message: this.$t('returnDetail.baseForm.inboundStorageNoPlaceholder'),
            },
          ],
          deliveryExpenseTaker: [
            {
              required: true,
              message: this.$t('returnDetail.baseForm.deliveryExpenseTakerPlaceholder'),
            },
          ],
          inboundExpenseTaker: [
            {
              required: true,
              message: this.$t('returnDetail.baseForm.inboundExpenseTakerPlaceholder'),
            },
          ],
          contractNo: [
            {
              required: true,
              message: this.$t('returnDetail.baseForm.contractNoPlaceholder'),
            },
          ],
        };
      },
      baseDataCopyRules() {
        return {
          returnDepartmentCode: [
            {
              required: true,
              message: this.$t('returnDetail.baseForm.returnDepartmentCodePlaceholder'),
            },
          ],
          returnSalesmanCode: [
            {
              required: true,
              message: this.$t('returnDetail.baseForm.returnSalesmanCodePlaceholder'),
            },
          ],
          returnCompanyCode: [
            {
              required: true,
              message: this.$t('returnDetail.baseForm.returnCompanyCodePlaceholder'),
            },
          ],
          purchaseUnitNo: [
            {
              required: true,
              message: this.$t('returnDetail.baseForm.purchaseUnitNoPlaceholder'),
            },
          ],
          returnRealObject: [
            {
              required: true,
              message: this.$t('returnDetail.baseForm.returnRealObjectPlaceholder'),
            },
          ],
          // returnMethod: [
          //   {
          //     required: true,
          //     message: this.$t("returnDetail.baseForm.returnMethodPlaceholder")
          //   }
          // ],
          returnMoney: [
            {
              required: true,
              message: this.$t('returnDetail.baseForm.returnMoneyPlaceholder'),
            },
          ],
          returnMoneyMethod: [
            {
              required: true,
              message: this.$t('returnDetail.baseForm.returnMoneyMethodPlaceholder'),
            },
          ],
          changeMethod: [
            {
              required: true,
              message: this.$t('returnDetail.baseForm.changeMethodPlaceholder'),
            },
          ],
          outboundStorageNo: [
            {
              required: true,
              message: this.$t('returnDetail.baseForm.outboundStorageNoPlaceholder'),
            },
          ],
          outboundExpenseTaker: [
            {
              required: true,
              message: this.$t('returnDetail.baseForm.outboundExpenseTakerPlaceholder'),
            },
          ],
          exchangeAddress: [
            {
              required: true,
              message: this.$t('returnDetail.baseForm.exchangeAddressPlaceholder'),
            },
          ],
          contractNo: [
            {
              required: true,
              message: this.$t('returnDetail.baseForm.contractNoPlaceholder'),
            },
          ],
        };
      },
      saleContract() {
        return {
          query: {
            contractNo: '',
          },
          API: API.LIST_CONTRACT,
          extraData: {
            contractCategory: 'sales',
            contractStatus: 'ZT03',
            customerNo: this.baseData.purchaseUnitNo,
            contractBusinessDepartment: this.baseData.returnDepartmentCode,
            supplierNo: this.baseData.returnCompanyCode,
          },
          propName: 'contractNo', // 输入框展示内容
          propCode: 'contractNo',
          searchColumns: [
            {
              prop: 'contractNo',
              name: '合同号',
              type: 'input',
              placeholder: '请输入',
            },
          ],
          columnList: [
            {
              prop: 'contractNo',
              label: '合同号',
              width: 200,
            },
            {
              prop: 'externalContractNo',
              label: '外部合同号',
              width: 200,
            },
            {
              prop: 'contractStatusName',
              label: '合同状态',
            },
          ],
        };
      },
    },
    mounted() {
      this.rules = this.baseDataRules;
      this.getDicData();
      this.companyOptions = JSON.parse(this.userInfo.companyList);
      this.currencyApi = DataBaseAPI.LIST_CURRENCY;
      this.currencyData = {};
      if (this.$route.name == 'returnAdd') {
        this.baseData.returnOperatorCode = this.userInfo.userCode;
        this.baseData.returnOperatorName = this.userInfo.userName;
        this.baseData.returnSalesmanCode = this.userInfo.userCode;
        this.baseData.returnSalesmanName = this.userInfo.userName;
      }
      this.$nextTick(() => {
        this.$refs.baseForm.clearValidate();
        this.getExtraData();
      });
    },
    methods: {
      //销售合同
      setSearchModal(model, row) {
        this.baseData.contractNo = row ? row[0].contractNo : null;
        this.baseData.currencyCode = row ? row[0].contractCurrency : null;
        this.baseData.currencyName = row ? row[0].contractCurrencyName : null;
        this.baseData.tradeType = row ? row[0].tradeType : null;
        this.$emit('searchModalContractNo', row);
        this.$emit('clearGoodsTable');
      },
      //合作伙伴额外参数 客户
      getExtraData() {
        this.baseData.extraDatapCustomer = {
          partnerTypes: 'HZHB01,HZHB03',
          companyCode: this.baseData.returnCompanyCode,
          departmentCode: this.baseData.returnDepartmentCode,
        };
      },
      chooseTable(row) {
        console.log(row);
      },
      changereturnRealObject(val) {
        if (val == 1) {
          this.rules = this.baseDataCopyRules;
        } else {
          this.rules = this.baseDataRules;
        }
        this.$nextTick(() => {
          this.$refs.baseForm.clearValidate();
        });
      },
      getDetail(allDetail) {
        let baseData = {};
        this.returnStatus = allDetail.returnStatus;
        Object.keys(this.baseData).forEach((item) => {
          if (item == 'returnMoney' || item == 'returnRealObject') {
            baseData[`${item}`] =
              allDetail[`${item}`] != undefined ? String(allDetail[`${item}`]) : '';
          } else {
            baseData[`${item}`] = allDetail[`${item}`] || '';
          }
        });
        this.baseData = baseData;
        if (this.baseData.returnRealObject == 1) {
          this.rules = this.baseDataCopyRules;
        } else {
          this.rules = this.baseDataRules;
        }
        this.$nextTick(() => {
          this.$refs.baseForm.clearValidate();
          this.getExtraData();
        });
        if (this.baseData.returnCompanyCode) this.initDepartment();
      },
      getReturnMoneyAmount(returnMoneyAmount) {
        this.baseData.returnMoneyAmount = returnMoneyAmount;
      },
      getTotalReturnQuantity(totalReturnQuantity) {
        this.baseData.totalExchangeQuantity = totalReturnQuantity;
      },
      getDeliveryExpenseAmount(deliveryExpenseAmount) {
        this.baseData.deliveryExpenseAmount = deliveryExpenseAmount;
      },
      getNonInvoiceQuantity(nonInvoiceQuantity) {
        this.baseData.nonInvoiceQuantity = nonInvoiceQuantity;
      },
      getInvoiceAmount(invoiceAmount) {
        this.baseData.invoiceAmount = invoiceAmount;
      },
      getDicData() {
        const tenantCode = this.userInfo.tenantCode; // 租户编码
        console.log(tenantCode);
      },
      //业务部门
      initDepartment() {
        const params = {
          id: this.userInfo.userCode,
          userCode: this.userInfo.userCode,
          personName: this.userInfo.userName,
          personCompanyCode: this.baseData.returnCompanyCode,
        };
        this.$axios.post(DataBaseAPI.GET_PERSON_API, params).then((res) => {
          if (0 == res.data.code) {
            this.departmentOptions = res.data.data.personDepartmentInfo;
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      //获取公司信息
      async getCompany() {
        const params = {
          id: this.userInfo.userInfo.userCode,
          userCode: this.userInfo.userInfo.userCode,
          personName: this.userInfo.userInfo.userName,
        };
        const selectStatus = await this.$axios.post(API.GET_PERSON_API, params);
        if (selectStatus.data.code == 0) {
          this.companyOptions == selectStatus.data.data.personCompanyInfo || [];
        }
      },
      changeCompany(val) {
        this.departmentOptions = [];
        this.baseData.returnDepartmentCode = '';
        this.baseData.returnDepartmentName = '';
        this.baseData.purchaseUnitName = '';
        this.baseData.purchaseUnitNo = '';
        this.baseData.contractNo = null;
        this.getExtraData();
        this.companyOptions.find((item) => {
          if (item.personCompanyCode === val) {
            this.baseData.returnCompanyName = item.personCompanyName;
            this.initDepartment();
          }
        });
        this.$emit('changeCompany', val);
      },
      focusChange() {
        this.$emit('focusChange', this.baseData.returnCompanyCode);
      },
      changeBlur() {
        this.$emit('changeBlur', this.baseData.returnCompanyCode);
      },
      //业务部门
      changeDepartment(val) {
        this.departmentOptions.map((item) => {
          if (item.personDepartmentCode == val) {
            this.baseData.returnDepartmentName = item.personDepartmentName;
          }
        });
        this.$refs.SearchTable.blurModal();
        this.baseData.purchaseUnitName = '';
        this.baseData.purchaseUnitNo = '';
        this.baseData.contractNo = null;
        this.$emit('clearGoodsTable');
        this.getExtraData();
      },
      // 退货方式：选择客户送货时，
      changeReturnMethod(val) {
        this.baseData.deliveryAddress = null;
        // 退货方式选择客户送货时
        if (val == 'THFS02') {
          this.baseData.deliveryAddress = this.deliveryAddress;
        }
      },
      //是否退款
      changeReturnMoney(val) {
        if (val == '1') {
          this.baseData.returnMoneyMethod = '';
        }
      },
      // 设置操作人
      setReturnOperatorCode(row) {
        this.baseData.returnOperatorCode = row ? row[0].id : null;
        this.baseData.returnOperatorName = row ? row[0].personName : null;
      },
      // 设置业务员
      setReturnSalesmanCode(row) {
        this.baseData.returnSalesmanCode = row ? row[0].id : '';
        this.baseData.returnSalesmanName = row ? row[0].personName : '';
      },
      // 设置客户
      setPurchaseUnitNo(row) {
        this.baseData.contractNo = null;
        this.baseData.purchaseUnitNo = row ? row[0].partnerCode : '';
        this.baseData.purchaseUnitName = row ? row[0].partnerZhName : '';
        this.$emit('clearGoodsTable');
      },
      // 设置入库仓库
      setInboundStorageNo(row) {
        //this.baseData.isDirectDeliver = row?row[0].isDirectDeliver:'';
        this.baseData.inboundStorageNo = row ? row[0].storageCode : '';
        this.baseData.inboundStorageName = row ? row[0].storageName : '';
        this.deliveryAddress = row ? row[0].storageAddress : '';
        if (this.baseData.returnMethod == 'THFS02') {
          this.baseData.deliveryAddress = row ? row[0].storageAddress : '';
        }
      },
      // 设置出库仓库
      setOutboundStorageNo(row) {
        this.baseData.outboundStorageNo = row ? row[0].storageCode : '';
        this.baseData.outboundStorageName = row ? row[0].storageName : '';
        this.$emit('setOutboundStorageNo', this.baseData.outboundStorageNo);
      },
      // 返回数据
      exportChildData(btnType) {
        if (btnType == 'ZT02') {
          // 点击提交，走校验
          let sign = false;
          this.$refs.baseForm.validate((valid) => {
            if (valid) {
              sign = true;
            } else {
              sign = false;
            }
          });
          return sign ? this.baseData : false;
        } else {
          return this.baseData;
        }
      },
    },
  };
</script>
<style lang="scss" scoped>
  .widthStyle {
    width: 100% !important;
  }
</style>
